/// <reference path="ListBase.js" />

class GameList extends ListBase {
	constructor(el, options) {
		super(el, Object.assign({ pagingEffect: 'returnToTop' }, options));
	}

	loadPage(page) {
		super.loadPage(page);
		this.standardJSONRequest(this.options.url.replace('PLH_pageNum', page));
	}
}
